import Swiper from 'swiper';

import { track } from '../utils/tracking';

const MOBILE_BREAKPOINT = 768;
const BASE_WIDTH = 1088;
const MOBILE_OFFSET = 15;
const MIN_DESKTOP_OFFSET = 32;

class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();

    this.initialScroll = true;
    this.slides = this.querySelectorAll('[data-slide]');

    const calculateOffset = () =>
      window.innerWidth < MOBILE_BREAKPOINT
        ? MOBILE_OFFSET
        : Math.max((window.innerWidth - BASE_WIDTH) / 2, MIN_DESKTOP_OFFSET);

    const swiper = new Swiper(this, {
      slidesOffsetBefore: calculateOffset(),
      slidesOffsetAfter: calculateOffset(),
      spaceBetween: 15,
      slidesPerView: 'auto',
      grabCursor: true,
      on: {
        slideChange: this.handleChange.bind(this),
      },
    });

    // Adjust offsets on window resize
    window.addEventListener('resize', () => {
      const newOffset = calculateOffset();
      swiper.params.slidesOffsetBefore = newOffset;
      swiper.params.slidesOffsetAfter = newOffset;
      swiper.update();
    });

    // Editor events
    this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
  }

  handleChange() {
    if (this.initialScroll) {
      this.initialScroll = false;
      track('testimonials_scroll');
    }
  }

  handleBlockSelect(e) {
    const index = [...this.slides].indexOf(e.target);
    this.swiper.slideTo(index);
  }
}

customElements.define('testimonials-slider', TestimonialsSlider);
